import DeviceStatuses from './DeviceStatuses';
import React from 'react';
import { LeakAlarmStatus } from '../features/Devices/leakAlarm';

const DeviceValues = ({ device, style, timeZone }) => {
  return (
    <>
      {device?.type?.key === 'counter' && <p className={style}>{device?.last_event?.value ? device?.last_event?.value + ' m³' : ''}</p>}
      {device?.type?.key === 'controller' && <DeviceStatuses device={device} style={'truncate text-gray-800'} icon={false} />}
      {device?.type?.sub_type?.key === 'sensor:water:leakage' && (
        <LeakAlarmStatus deviceId={device.id} timeZone={timeZone} compact />
      )}
      {device?.type?.sub_type?.key === 'sensor:temperature' && <p className={style}>{device?.last_event?.value ? device?.last_event?.value + ' °C' : ''} </p>}
    </>
  );
};

export default DeviceValues;
